import {Record, List} from 'immutable';
import moment, {type Moment} from 'moment-timezone';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';
import AccountItem from 'web-app/react/entities/account-items/model';

const Constants = {
    VOUCHER_METHOD: 'Voucher',
    FIRST_OF_MONTH: 'FIRST-OF-MONTH',
    LAST_OF_MONTH: 'LAST-OF-MONTH',
};

class PaymentMethod extends Record<{
    id: string;
    title: string;
}>({
    id: '',
    title: '',
}) {}

export class VoucherCompany extends Record<{
    voucherCompanyId: string;
    name: string;
}>({
    voucherCompanyId: '',
    name: '',
}) {}

class Period extends Record<{
    from: string;
    to: string;
}>({
    from: '',
    to: '',
}) {}

export class RecurringPayment extends Record<{
    recurringPaymentId: string;
    billPayerId: string;
    amount: number;
    paymentMethod: PaymentMethod;
    voucherCompany: VoucherCompany;
    recursEvery: string;
    firstPayment: Moment | null;
    lastPayment: Moment | null;
    payments: List<any>; // Account items
    firstPeriod: Period;
    lastPeriod: Period;
    recurrence: 'MONTHLY' | 'WEEKLY';
    behaviors: BehaviorsCollection;
}>({
    recurringPaymentId: '',
    billPayerId: '',
    amount: 0,
    paymentMethod: new PaymentMethod(),
    voucherCompany: new VoucherCompany(),
    recursEvery: Constants.FIRST_OF_MONTH,
    firstPayment: null,
    lastPayment: null,
    payments: List(),
    firstPeriod: new Period(),
    lastPeriod: new Period(),
    recurrence: 'MONTHLY',
    behaviors: new BehaviorsCollection([]),
}) {}

function fromAPI(data) {
    return new RecurringPayment({
        ...data,
        firstPayment: data.firstPayment ? moment(data.firstPayment, 'YYYY-MM-DD') : null,
        lastPayment: data.lastPayment ? moment(data.lastPayment, 'YYYY-MM-DD') : null,
        firstPeriod: data.firstPeriod ? new Period(data.firstPeriod) : null,
        lastPeriod: data.lastPeriod ? new Period(data.lastPeriod) : null,
        paymentMethod: data.paymentMethod ? new PaymentMethod(data.paymentMethod) : null,
        voucherCompany: data.voucherCompany ? new VoucherCompany(data.voucherCompany) : null,
        behaviors: data.behaviors ? new BehaviorsCollection(data.behaviors) : new BehaviorsCollection([]),
        payments: List(data.payments).map(AccountItem.fromAPI),
    });
}

function toAPI(recurringPayment) {
    return {
        recurringPaymentId: recurringPayment.recurringPaymentId,
        billPayerId: recurringPayment.billPayerId,
        amount: recurringPayment.amount,
        paymentMethod: recurringPayment.paymentMethod ? recurringPayment.paymentMethod.toJS() : {},
        voucherCompany: recurringPayment.voucherCompany ? recurringPayment.voucherCompany.toJS() : {},
        recursEvery: recurringPayment.recursEvery,
        firstPayment: recurringPayment.firstPayment ? recurringPayment.firstPayment.format('YYYY-MM-DD') : null,
        lastPayment: recurringPayment.lastPayment ? recurringPayment.lastPayment.format('YYYY-MM-DD') : null,
    };
}

export default {
    record: RecurringPayment,
    default: new RecurringPayment(),
    Constants,
    fromAPI,
    toAPI,
};
